import LayoutRegister from '@/layouts/login.vue';
import Register from '../../../modules/FolderAccounts/Register';

const routes = [
    {
        path: '/register',
        component: LayoutRegister,
        children: [
            {
                path: '',
                name: 'register',
                component: Register,
              
            }
        ],
        props: (route) => ({
            affcode: route.query.affcode,
            agcode: route.query.agcode,
          }),
        
    }
]

export default  routes ;